import type { Organization } from '@/types'
import type { OrganizationsState } from './state'

export const createGetters = (state: OrganizationsState) => {
  const filteredOrganizations = (): Organization[] => {
    let result = [...state.organizations]

    if (state.filters.search) {
      const search = state.filters.search.toLowerCase()
      result = result.filter(
        (org) =>
          org.name.toLowerCase().includes(search) ||
          org.email?.toLowerCase().includes(search)
      )
    }

    if (state.filters.isActive !== null) {
      result = result.filter((org) => org.isActive === state.filters.isActive)
    }

    return result
  }

  const getOrganizationById = (orgId: string): Organization | undefined => {
    return state.organizations.find((org) => org.id === orgId)
  }

  const activeOrganizations = (): Organization[] => {
    return state.organizations.filter((org) => org.isActive)
  }

  const totalOrganizations = (): number => {
    return state.organizations.length
  }

  const totalActiveOrganizations = (): number => {
    return state.organizations.filter((org) => org.isActive).length
  }

  return {
    filteredOrganizations,
    getOrganizationById,
    activeOrganizations,
    totalOrganizations,
    totalActiveOrganizations,
  }
}
